<template>

    <div class="col span_4_of_12 lw-course-card flexible">

        <div :style="courseCardStyles" class="learnworlds-image learnworlds-bg-default stretched-bg learnworlds-framed-image learnworlds-element rectangle learnworlds-frame-size-full"></div>

        <div class="lw-white-bg lw-padding-small learnworlds-element">
            <p class="lw-brand-text learnworlds-overline-text learnworlds-letter-casing-uppercase learnworlds-element">Label</p>
            <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">{{title}}</h3>
            <p class="lw-course-card-descr learnworlds-main-text learnworlds-main-text-small learnworlds-line-height-large learnworlds-element lw-text-color-fadeout20" >{{description}}</p>
            <course-card-button></course-card-button>
        </div>
        
    </div>

</template>

<script>

    import CourseCardButton from './CourseCardButton.vue';

    export default {
        data () {
            return {}
        },
        props : {
            courseData : {
                type: Object,
            },
            cardTemplate : {
                type: String,
            },
            courseImage : {
                type: Object || String,
            },
            title : {
                type: String
            },
            description: {
                type: String
            },
        },
        computed : {
            cardBackgroundImage () {

                return this.courseData.courseImage && this.courseData.courseImage.url ? "url('" + this.courseData.courseImage.url + "')" : "";
            },
            courseCardStyles () {

                let styleObj = {};

                if (this.cardBackgroundImage && this.cardBackgroundImage.indexOf("course-default-img") === -1) {
                    styleObj["background-image"] = this.cardBackgroundImage;
                }

                return styleObj;
            }

        },
        mounted () {
            console.log()
        },
        components: {
            CourseCardButton
        }
    }
</script>
